export const calculateTopOffset = (elementSelector?: string, offset = 0) => {
  if (!elementSelector) {
    return offset;
  }

  const element = document.querySelector(elementSelector);
  if (!element) {
    return offset;
  }

  const header = document.querySelector("header");
  const headerHeight = header ? header.offsetHeight : 0;

  const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

  const offsetTop = elementTop - headerHeight;

  return Math.max(0, offsetTop - offset);
};

interface ScrollToTopDetail {
  behaviour?: ScrollBehavior;
  selector?: string;
  offset?: number;
}

window.addEventListener("scroll-to-top", (event) => {
  const { detail } = event as CustomEvent<ScrollToTopDetail>;
  const behaviour = detail?.behaviour ?? "smooth";
  const elementSelector = detail?.selector;
  const offset = detail?.offset ?? 0;

  const topOffset = calculateTopOffset(elementSelector, offset);

  window.scrollTo({
    top: topOffset,
    behavior: behaviour,
  });
});
